import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageResp } from 'src/app/core/models/page/page-response';
import { environment } from 'src/environments/environment';
import { AirportMaintenanceGetRequest } from '../pages/ariport-maintenance/interfaces/airport-maintenance-get-request';
import { AirportMaintenanceSaveRequest } from '../pages/ariport-maintenance/interfaces/airport-maintenance-save-request';
import { AirportMaintenanceTableData } from '../pages/ariport-maintenance/interfaces/airport-maintenance-table-data';

@Injectable({
  providedIn: 'root'
})
export class AirportMaintenanceService {

  private baseUrl: string = `${environment.logisticsApiUrl}/facilityOptions`
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }
  constructor(
    private http: HttpClient
  ) { }

  findAirport(request: AirportMaintenanceGetRequest): Observable<PageResp<AirportMaintenanceTableData>> {
    const url = this.baseUrl + '/findAirport'
    return this.http.post<PageResp<AirportMaintenanceTableData>>(url, request, this.httpOptions);
  }

  saveChanges(request: AirportMaintenanceSaveRequest): Observable<void> {
    const url = this.baseUrl + '/saveAirportChanges'
    return this.http.post<void>(url, request, this.httpOptions);
  }
}
